import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { HvlAuthenticatedGuard, HvlAuthorizationGuard } from '@hvlng/framework-bff/security';
import { HrRecMainComponent } from './hr-rec-main.component';
import { RouteConfigGuard } from 'ui-shared';
import { RToolRoutingModule } from '@hvlng/report-lib';
import {HvlCommonRoutingConstant} from "@hvlng/framework-theme";
import { KOVAN_THEME_PAGES } from '@kovan/theme';

const routes: Routes = [
    {
        path: '',
        canActivate: [RouteConfigGuard],
        children: [
            {
                path: '',
                component: HrRecMainComponent,
                canActivate: [HvlAuthenticatedGuard, HvlAuthorizationGuard, RouteConfigGuard],
            },
            {
                path: 'humanresources/recruitment',
                component: HrRecMainComponent,
                canActivate: [HvlAuthenticatedGuard, HvlAuthorizationGuard],
                loadChildren: () => import('./module/hr-rec-agg.module').then((m) => m.HrRecAggModule),
            },
            {
                path: 'general',
                component: HrRecMainComponent,
                canActivate: [HvlAuthenticatedGuard],
                loadChildren: () => import('@kovan/infrastructure').then((m) => m.InfraAggModule),
            },
            {
                path: RToolRoutingModule.rtoolRoutePath,
                loadChildren: () => import('@hvlng/report-lib').then((m) => m.RToolModule),
            },


        ],
    },
    {
        path: 'humanresources/recruitment/public',
        loadChildren: () => import('./module/public/recruitment-public-pages.module').then((m) => m.RecruitmentPublicPagesModule),
    },

];
routes.push(...KOVAN_THEME_PAGES);
@NgModule({
    imports: [RouterModule.forRoot(routes)],
    exports: [RouterModule],
    providers: [RouteConfigGuard],
})
export class HrRecAppRoutingModule {}
